import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    OrderSubprocess,
    CreateOrderSubprocessInput,
    UpdateOrderSubprocessInput,
    ModelOrderSubprocessFilterInput,
    ModelSortDirection,
    DeleteOrderSubprocessInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class OrderSubprocessService {
    private amplifyClient = generateClient();

    constructor() {}

    async premiumSubprocessesByClient(
        clientId: string,
        filter: ModelOrderSubprocessFilterInput = null,
        sortDirection: ModelSortDirection = ModelSortDirection.ASC
    ): Promise<OrderSubprocess[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.OrderSubprocessesByClient,
                    variables: {
                        clientId,
                        filter,
                        sortDirection
                    }
                })
            ).data.OrderSubprocessesByClient.items;
            if (data) return data as OrderSubprocess[];
        } catch (error) {
            console.error('Error OrderSubprocessesByClient:', error);
            return null;
        }
    }

    async listPremiumOrderSubprocessByProcessId(
        processId: string,
        filter: ModelOrderSubprocessFilterInput = null,
        sortDirection: ModelSortDirection = ModelSortDirection.ASC
    ): Promise<OrderSubprocess[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.OrderSubprocessesByProcess,
                    variables: {
                        processId,
                        filter,
                        sortDirection
                    }
                })
            ).data.OrderSubprocessesByProcess.items;
            if (data) return data as OrderSubprocess[];
        } catch (error) {
            console.error('Error finding subprocess:', error);
            return null;
        }
    }

    async getPremiumOrderSubprocess(id: string): Promise<OrderSubprocess> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getOrderSubprocess,
                    variables: {
                        id
                    }
                })
            ).data.getOrderSubprocess;
            if (data) return data as OrderSubprocess;
        } catch (error) {
            console.error('Error finding subprocess:', error);
            return null;
        }
    }

    async createPremiumOrderSubprocess(
        input: CreateOrderSubprocessInput
    ): Promise<OrderSubprocess> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createOrderSubprocess,
                    variables: {
                        input
                    }
                })
            ).data.createOrderSubprocess;
            if (data) return data as OrderSubprocess;
        } catch (error) {
            console.error('Error creating subprocess:', error);
            return null;
        }
    }

    async updatePremiumOrderSubprocess(
        input: UpdateOrderSubprocessInput
    ): Promise<OrderSubprocess> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateOrderSubprocess,
                    variables: {
                        input
                    }
                })
            ).data.updateOrderSubprocess as OrderSubprocess;
            if (data) return data;
        } catch (error) {
            console.error('Error updating subprocess:', error);
            return null;
        }
    }

    async createPopOrderSubprocess(
        input: CreateOrderSubprocessInput
    ): Promise<OrderSubprocess> {
        return this.createPremiumOrderSubprocess(input);
    }

    async updatePopOrderSubprocess(
        input: UpdateOrderSubprocessInput
    ): Promise<OrderSubprocess> {
        return this.updatePremiumOrderSubprocess(input);
    }

    async createPrintedOrderSubprocess(
        input: CreateOrderSubprocessInput
    ): Promise<OrderSubprocess> {
        return this.createPremiumOrderSubprocess(input);
    }

    async updatePrintedOrderSubprocess(
        input: UpdateOrderSubprocessInput
    ): Promise<OrderSubprocess> {
        return this.updatePremiumOrderSubprocess(input);
    }

    async deletePremiumOrderSubprocess(
        input: DeleteOrderSubprocessInput
    ): Promise<OrderSubprocess> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteOrderSubprocess,
                    variables: {
                        input
                    }
                })
            ).data.deleteOrderSubprocess as OrderSubprocess;
            if (data) return data;
        } catch (error) {
            console.error('Error deleting subprocess:', error);
            return null;
        }
    }
}
